import { useMutation } from '@tanstack/react-query';

import BackendService from '../services/backendService';
import { Template } from '../services/TemplateService/Template.type';

function useExport() {
  const {
    mutate: createToken,
    isSuccess: createTokenSuccess,
    isPending: isCreatingToken,
    data: tokenResponse,
  } = useMutation({
    mutationFn: ({
      email,
      activeTenantId,
    }: {
      email?: string;
      activeTenantId?: string;
      onSuccessFunction?: (data: Template) => void;
    }) => BackendService.instance.export.createToken({ activeTenantId, email })
  });

  const {
    mutate: checkToken,
    isSuccess: checkTokenSuccess,
    isPending: isCheckingToken,
    data: checkTokenResponse,
    isError: isCheckTokenError,
  } = useMutation({
    mutationFn: ({
      token,
      activeTenantId,
    }: {
      token: string;
      activeTenantId?: string;
      onSuccessFunction?: (data: Template) => void;
    }) => BackendService.instance.export.checkToken({ activeTenantId, token })
  });

  const {
    mutate: executeExport,
    isSuccess: executeExportSuccess,
    isPending: isExecutingExport,
    error: executeExportError,
  } = useMutation({
    mutationFn: ({
      token,
      activeTenantId,
    }: {
      token: string;
      activeTenantId?: string;
      onSuccessFunction?: (data: Template) => void;
    }) => BackendService.instance.export.execute({ activeTenantId, token })
  });

  return {
    createToken,
    createTokenSuccess,
    isCreatingToken,
    isCheckTokenError,
    tokenResponse,
    checkToken,
    checkTokenSuccess,
    isCheckingToken,
    checkTokenResponse,
    executeExport,
    executeExportSuccess,
    isExecutingExport,
    executeExportError,
  };
}

export default useExport;
